import { Box, styled, Typography } from "@mui/material"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  flex: 1,
  paddingTop: 120,
})

export const MessageContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
})

export const Title = styled(Typography)({
  maxWidth: 215,
  margin: "30px 0 20px 0",
  textAlign: "center",
})

export const Subtitle = styled(Typography)({
  maxWidth: 313,
  textAlign: "center",
})
